package com.schoolconnect.app.feature.common

/**
 * Coordinates the replaceable work shared by server-backed admin lists.
 * Feature ViewModels still own state, filters, repository calls, and mapping;
 * this class only centralizes debounce, bootstrap, page cancellation, and cleanup.
 */
internal class AdminPagedListCoordinator(
    private val debouncer: DebouncedActionRunner,
    private val bootstrap: AdminBootstrapSequencer
) {
    fun schedulePage(
        immediate: Boolean = false,
        forceRemote: Boolean = false,
        loadPage: suspend (forceRemote: Boolean) -> Unit
    ) {
        debouncer.submit(immediate = immediate) {
            bootstrap.launchPage(forceRemote = forceRemote, onPage = loadPage)
        }
    }

    fun requestPage(
        forceRemote: Boolean,
        immediate: Boolean = false,
        loadPage: suspend (forceRemote: Boolean) -> Unit
    ) {
        if (immediate) {
            refreshPage(forceRemote = forceRemote, loadPage = loadPage)
        } else {
            schedulePage(forceRemote = forceRemote, loadPage = loadPage)
        }
    }

    fun refresh(
        forceRemote: Boolean,
        loadAnalytics: suspend () -> Unit,
        loadPage: suspend (forceRemote: Boolean) -> Unit
    ) {
        bootstrap.startBootstrap(
            forceRemote = forceRemote,
            onAnalytics = loadAnalytics,
            onPage = loadPage
        )
    }

    fun refreshPage(
        forceRemote: Boolean,
        loadPage: suspend (forceRemote: Boolean) -> Unit
    ) {
        bootstrap.launchPage(forceRemote = forceRemote, onPage = loadPage)
    }

    fun clear() {
        debouncer.cancel()
        bootstrap.clear()
    }
}
